import { get, post } from './../Config/config';

export const Projects = {
    getProjectList: (data) => get(`/user-projects`, { params: data }),
    add: (data) => post('/lead/assign-note', data),
    allProject: (data) => get(`/all-projects`, { params: data }),
} 